export const gridSpacing = 3;

export const gridColumnProps = {
    alignContent: "flex-start",
    alignItems: "start",
    container: true,
    item: true,
    spacing: gridSpacing,
};
